import React, { Component } from 'react';
import Map from './Map';
import Monitor from './Monitor';
import Environment from './Environment';
import Sensor from './Sensor';
import Realname from './Realname';
import Bimmoel from './BIMmodel';
import Engineering from './Engineering';
import Project from './Project';
import './index.styl';

const clzpre = 'ssfe-dashboard';

class Dashboard extends Component {
    render() {
        return <div className={clzpre}>
            <Map />
            <section>
                <ul className={`${clzpre}-left`}>
                    <li>
                        <Monitor />
                    </li>
                    <li>
                        <Environment />
                    </li>
                    <li>
                        <Sensor />
                    </li>
                </ul>
                <ul className={`${clzpre}-center`}>
                    <li></li>
                    <li>
                        <Realname />
                    </li>
                </ul>
                <ul className={`${clzpre}-right`}>
                    <li>
                        <Bimmoel />
                    </li>
                    <li>
                        <Engineering />
                    </li>
                    <li>
                        <Project />
                    </li>
                </ul>
            </section>
        </div>;
    }
}

export default Dashboard;